import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13cfcc53"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "pagination",
  "data-test": "pagination"
}

import { withDefaults } from 'vue'

type PropsType = {
  total?: number
  currentPage?: number
  pageSize?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    total: { default: 50 },
    currentPage: { default: 1 },
    pageSize: { default: 10 }
  },
  emits: ["currentChange"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'currentChange', page: number): void
}), expose: any, slots: any, attrs: any }) {





const handleCurrentChange = (page: number) => {
  emit('currentChange', page)
}

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_pagination, {
      layout: "prev, pager, next",
      total: __props.total,
      currentPage: __props.currentPage,
      pageSize: __props.pageSize,
      "pager-count": 5,
      onCurrentChange: handleCurrentChange
    }, null, 8, ["total", "currentPage", "pageSize"])
  ]))
}
}

})